var TrackingHelper;

TrackingHelper = (function() {
  function TrackingHelper() {
    this.recordedFirstPage = false;
  }

  TrackingHelper.prototype.pageReady = function() {
    if (this.recordedFirstPage) {
      return;
    }
    if (!Groupon.Performance) {
      return;
    }
    Groupon.Performance.pageReady();
    return this.recordedFirstPage = true;
  };

  return TrackingHelper;

})();

module.exports = TrackingHelper;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9icm93c2UvZnJvbnRlbmQvaGVscGVycy90cmFja2luZy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9hYnNoYXJtYS9uYXBpc3RyYW5vL2J1aWxkLzE0ODY2NzU2MjQyNzQtNzQzNy9zdGFnaW5nLXBlcmYtMjAxNy4wMi4wOV8wMC4zNS9nb29kcy9tb2R1bGVzL2Jyb3dzZS9mcm9udGVuZC9oZWxwZXJzL3RyYWNraW5nLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxJQUFBOztBQUFNO0VBQ1Msd0JBQUE7SUFDWCxJQUFDLENBQUEsaUJBQUQsR0FBcUI7RUFEVjs7MkJBR2IsU0FBQSxHQUFXLFNBQUE7SUFDVCxJQUFHLElBQUMsQ0FBQSxpQkFBSjtBQUEyQixhQUEzQjs7SUFDQSxJQUFHLENBQUksT0FBTyxDQUFDLFdBQWY7QUFBZ0MsYUFBaEM7O0lBRUEsT0FBTyxDQUFDLFdBQVcsQ0FBQyxTQUFwQixDQUFBO1dBRUEsSUFBQyxDQUFBLGlCQUFELEdBQXFCO0VBTlo7Ozs7OztBQVFiLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
